import React from 'react';
import { FormSection } from 'redux-form/immutable';
import { email, required } from 'redux-form-validators';
import { Form, Checkbox, Input } from 'semantic-ui-react';

import FormField from '~/views/common/FormField';
import Section from '~/views/common/Section';


const ContactForm = () => (
    <Section name="Contact">
        <FormSection name="contact">
            <Form.Group>
                <FormField
                    name="private_email"
                    label="Private Email"
                    control={Checkbox}
                />
                <FormField
                    name="private_name"
                    label="Private Name"
                    control={Checkbox}
                />
            </Form.Group>

            <FormField
                name="email"
                label="Email"
                placeholder="Email"
                control={Input}
                validate={email()}
                required
                width={10}
            />

            <Form.Group>
                <FormField
                    name="firstname"
                    label="First name"
                    placeholder="First name"
                    control={Input}
                    validate={required()}
                    required
                />
                <FormField
                    name="lastname"
                    label="Last name"
                    placeholder="Last name"
                    control={Input}
                    validate={required()}
                    required
                />
            </Form.Group>

            <Form.Group grouped widths={6}>
                <FormField
                    name="office"
                    label="Office"
                    placeholder="Office"
                    control={Input}
                />
                <FormField
                    name="phone"
                    label="Phone"
                    placeholder="Phone"
                    control={Input}
                />
            </Form.Group>
        </FormSection>
    </Section>
);

export default ContactForm;
